import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getCellClassName } from './util';

export default class GridItem extends Component {
    static defaultProps = {
        columnSpan: 3,
        rowSpan: 1,
        offsetColumn: 0,
    };

    render() {
        const { children, className, style, rowSpan, columnSpan, offsetColumn, ...restProps } = this.props;
        const wrapCls = classnames("grid-cell", className, ...getCellClassName(rowSpan, columnSpan, offsetColumn));
        const wrapStyle = Object.assign({}, style);
        const placeholderDom = (
            <div className='placeholder-dom'>拖拽到此处</div>
        )
        return (
            <div className={wrapCls} style={wrapStyle} {...restProps}>
                {
                    children ? children : placeholderDom
                }
            </div >
        );
    }
}
GridItem.propTypes = {
    offsetColumn: PropTypes.number,
    columnSpan: PropTypes.number,
    rowSpan: PropTypes.number,
    style: PropTypes.object,
    className: PropTypes.string,
};